export const DAlignHorizontal = wcardinal.ui.DAlignHorizontal;